import React from 'react';

/* eslint-disable max-len,no-tabs,camelcase */
const Hair_16 = ({ hairColours }) => {
  const primary = hairColours.base;
  const secondary = hairColours.shadow;
  return (
    <>
      <g>
        <path
          fill={primary}
          d="M303.9,276.1c0,0-35.9,39.6-28.1,87.1c6.5,39.7,68.4,102.8,68.4,102.8s-53.1-70.8-59.4-108
		C278.6,320.7,303.9,276.1,303.9,276.1z"
        />
        <path
          fill={primary}
          d="M477.7,259.3c0,0,41.9,35.1,41.8,83c-0.1,40-30.2,110.4-30.2,110.4s20.1-77,20.4-114.5
		C510,300.6,477.7,259.3,477.7,259.3z"
        />
        <g>
          <path
            fill={primary}
            d="M521.3,190.2c0,0-115.9-95.8-219.8-15.5c0,0-13.4,26.2,2.8,35.9C364.6,246.5,529.6,300.4,521.3,190.2z"
          />
          <g>
            <path
              fill={primary}
              d="M491.8,245.2c0,0,4.9,33.5,3.5,53c-1.4,19.4-4.4,23.8-4.4,23.8L447,320c0,0-1.1-12.4-1.9-28.1
				c-0.9-15.7-2.5-29.5-2.5-29.5s0.8,17-0.1,37.7c-0.7,16.3-2.8,20.6-2.8,20.6l-19.4,0.5c0,0-0.1-16.3,0.5-25.3
				c0.7-9.1,0.4-33.2,0.4-33.2s-7.4,37.2-8.7,45.6c-1.3,8.4-1.6,12.3-1.6,12.3l-58.1,0.3c0,0-4.1-8.1-6.3-23.2
				c-2.2-15.1-0.1-35.1-0.1-35.1s-4.6,27-4.2,38.7c0.5,11.7,1.7,22.9,1.7,22.9l-20-0.2c0,0-4.8-6.9-8.4-22.1
				c-3.6-15.2-2.2-33.4-2.2-33.4s-4.3,31.6-3,41.4c1.3,9.9,3.6,15.2,3.6,15.2l-22.1,1c0,0-13.7-14-6.9-51.3
				c6.7-37.3,44.2-85.3,109-86.4C458.6,187.5,491.8,245.2,491.8,245.2z"
            />
            <path
              fill={primary}
              d="M490.1,258.8c0,0,11.1,40.5,10.3,88c-0.8,47.4-11.3,109.2-14.9,121.9c-3.6,12.8-6,17.8-6,17.8
				s19.9-17.4,26.5-25.4c6.6-8,12-18,12-18l6.7-18.4l-3.4,19.3c0,0,18.7-18.2,22.5-25C547.7,412,554,389,554,389l-1.8,15.5
				c0,0,26.6-35.2,25.3-91.2c-1.3-56.1-35.8-103.5-53.2-121C506.9,174.7,490.1,258.8,490.1,258.8z"
            />
            <path
              fill={primary}
              d="M490.1,258.8c0,0,15.7,41.5,14.9,88.9c-0.8,47.4-12.1,102.6-15.7,115.3c-3.6,12.8-3.8,16-3.8,16
				s14.1-10,20.7-18c6.6-8,7.4-19.6,7.4-19.6l15.1-52.3l-2.2,38.9c0,0,10-9.7,13.9-16.6c3.8-6.9,17.2-61.9,17.2-61.9l-1.7,42.2
				c0,0,23-22.4,21.7-78.5c-1.3-56.1-35.8-103.5-53.2-121C506.9,174.7,490.1,258.8,490.1,258.8z"
            />
            <path
              fill={primary}
              d="M294.1,249c0,0-13.1,82.3-9,128.4c5.9,66.1,51,110.9,51,110.9s-20.1,1.1-40.2-15.9
				c-20.1-17.1-36.1-53.4-36.1-53.4l5.9,19.3c0,0-18.9-24.2-29.2-47.7c-10.3-23.5-18-63.8-8.2-116.4c9.8-52.6,65.4-92.2,73.3-99.4
				C309.3,167.5,294.1,249,294.1,249z"
            />
            <path
              fill={primary}
              d="M294.1,249c0,0-12.9,67.9-12.8,114.1c0.2,74.1,47.1,120,47.1,120s-16.5,0.3-33.9-19.4
				c-22.8-25.7-43.6-88.4-43.6-88.4l6.6,46.7c0,0-7-13.5-17.3-37.1c-10.3-23.5-21.8-58.2-11.9-110.8c9.8-52.6,65.4-92.2,73.3-99.4
				C309.3,167.5,294.1,249,294.1,249z"
            />
            <path
              fill={secondary}
              d="M419.6,210.7c8.9-3.3,15-4.1,22.7,0.3c7.7,4.5,8.9,5.9,13.6,5.5c4.7-0.3,3.4-9.5,9.2-7.8
				c5.1,1.5,11.8,12.6,22.6,10.8c10.8-1.8,8.1-2,13.6-2.9c5.4-0.9,7.3-8.6,13.4-9.4c6.1-0.9,27.4,26.7,30.4,40
				c3,13.2,5.2,38.1-6.1,28.2c-11.3-9.9-28.2-33.9-39.8-30.2c-11.6,3.7-13.2,16.6-23.1,14.6c-9.9-2-10.5-11.2-17.2-11
				c-6.7,0.2-7.3,8.6-15.9,8c-8.6-0.6-8.8-25.4-23.1-21.2c-14.3,4.2-27.4,27.9-42,27.5c-14.6-0.4-16.9-15.5-22.8-16
				c-6-0.4-9.5,11.7-16.8,10.5c-7.3-1.2-7.2-10.9-13.9-10.1c-6.7,0.8-21.4,18.6-30.6,16.6c-9.2-2-2-8.6-8.6-10.4
				c-6.5-1.8-3.8,6.9-13.8,6.2c-10-0.7-8.3-5.2-15.2-1.8c-6.9,3.4-9.4,10.4-9.7,4.5c-0.2-5.9,11.1-33.7,24.8-47.6
				c13.7-14,21.7-23.1,27.5-20.8c5.8,2.4,6.6,10.2,18.4,12.4c11.8,2.2,20.9-2.4,30.2-2.4c9.3,0-0.3,4.5,18.9,5.9
				c0,0,8-10.2,21.8-2.9C401.9,214.4,419.6,210.7,419.6,210.7z"
            />
          </g>
        </g>
      </g>
    </>
  );
};

export default Hair_16;
